<!-- src/pages/Home.vue -->
<template>
  <BaseLayout title="Home" subtitle="Quick, assumption-aware cycle time estimates for robotics" :narrow="false">
    <!-- Hero card -->
    <section class="hero-card">
      <div class="hero-text">
        <h1 class="hero-title">Estimate robot cycle time with confidence</h1>
        <p class="hero-sub">
          Model multi-segment pick & place with realistic accel/vel limits, payload derating, and cornering blends.
        </p>
        <div class="hero-cta">
          <router-link to="/route" class="btn btn-primary">Open Robot Cycle Calculator</router-link>
          <router-link to="/how-to" class="btn btn-ghost">How to Use</router-link>
        </div>
        <p class="hero-note">Designed for budgeting & concept work — validate final numbers with your robot vendor or integrator.</p>
      </div>
    </section>

    <!-- Features -->
    <section class="features">
      <article class="feature">
        <h3>Motion AI</h3>
        <p>Auto-selects jerk-limited profiles, applies robot-aware speed/accel caps and payload derating, and blends corners by %
           so stops only happen where needed.</p>
      </article>
      <article class="feature">
        <h3>AI Analysis</h3>
        <p>Explains bottlenecks (speed- vs accel-limited), flags unrealistic inputs, and suggests what-ifs that reduce total cycle.</p>
      </article>
      <article class="feature">
        <h3>Flexible Routes</h3>
        <p>Build with <strong>Waypoints</strong>, <strong>Segments</strong>, or <strong>Custom Segments</strong> — switch modes and keep data in sync.</p>
      </article>
    </section>
  </BaseLayout>
</template>

<script setup>
import BaseLayout from '@/components/BaseLayout.vue'
</script>

<style scoped>
/* hero */
.hero-card{
  background:#fff;
  border:1px solid #e5e7eb;
  border-radius:20px;
  box-shadow:0 12px 28px rgba(16,24,40,.06);
  padding:24px;
  max-width:980px;
  margin: 0 auto 18px;
}
.hero-title{ margin:0 0 .25rem; font-weight:800; letter-spacing:.2px; }
.hero-sub{ margin:.25rem 0 1rem; opacity:.85; }
.hero-cta{ display:flex; gap:.6rem; flex-wrap:wrap; margin:.5rem 0 .25rem; }
.hero-note{ font-size:.9rem; color:#5b667a; margin:.5rem 0 0; }

/* buttons */
.btn{ display:inline-flex; align-items:center; justify-content:center; height:40px; padding:0 14px; border-radius:999px; font-weight:800; font-size:.95rem; }
.btn-primary{ background:#9BB1CF; color:#fff; border:1px solid rgba(0,0,0,.04); text-decoration:none; }
.btn-primary:hover{ filter:brightness(.97); }
.btn-ghost{ background:#fff; color:#0B1220; border:1px solid #e5e7eb; text-decoration:none; }
.btn-ghost:hover{ background:#f9fafb; }

/* features row */
.features{
  display:grid; gap:14px; margin: 6px auto 0; max-width:980px;
  grid-template-columns: 1fr;
}
@media (min-width: 900px){
  .features{ grid-template-columns: 1fr 1fr 1fr; }
}
.feature{
  background:#fff; border:1px solid #e5e7eb; border-radius:14px; padding:14px;
  box-shadow:0 8px 20px rgba(16,24,40,.05);
}
.feature h3{ margin:.1rem 0 .35rem; font-weight:800; }
.feature p{ margin:0; line-height:1.55; }
</style>
